import { arrayOf, bool, func, number, shape, string } from 'prop-types'
import { AutoSizer, Column, Table, WindowScroller } from 'react-virtualized'
import React from 'react'
import ListItem from './ListItem'

const cellRenderer = props => (
  <ListItem
    city={props.cellData.city}
    country={props.cellData.country}
    hallUses={props.cellData.hall_uses}
    image={props.cellData.image}
    key={props.cellData._id}
    name={props.cellData.name}
    onClick={props.cellData.onClick}
    seatCount={props.cellData.seat_count}
    siteBuilding={props.cellData.site_building}
    stateProvinceAbbreviation={props.cellData.state_province_abbreviation}
    url={props.cellData.url}
    yearBuilt={props.cellData.year_built}
    yearRenovated={props.cellData.year_renovated}
  />
)
cellRenderer.propTypes = {
  cellData: shape({
    city: string,
    country: string,
    hall_uses: arrayOf(string),
    image: string,
    name: string.isRequired,
    onClick: func.isRequired,
    seat_count: number,
    site_building: string.isRequired,
    state_province_abbreviation: string,
    url: string.isRequired,
    year_built: number,
    year_renovated: arrayOf(number),
  }).isRequired,
}

const ListView = props => {
  if (props.useWindowScroller) {
    return (
      <div className="list-view view">
        <WindowScroller>
          {({
            height,
            isScrolling,
            registerChild,
            scrollTop,
          }) => (
            <AutoSizer disableHeight>
              {({ width }) => {
                return (
                  <div ref={registerChild}>
                    <Table
                      autoHeight
                      disableHeader
                      width={width}
                      height={height}
                      headerHeight={0}
                      isScrolling={isScrolling}
                      rowHeight={178}
                      rowCount={props.listItems.length}
                      rowGetter={({ index }) => {
                        const first = props.listItems[index]
                        first.onClick = props.onClick
                        return {
                          first,
                        }
                      }}
                      scrollTop={scrollTop}
                    >
                      <Column
                        cellRenderer={cellRenderer}
                        dataKey="first"
                        label="First"
                        width={width}
                      />
                    </Table>
                  </div>
                )
            }}
            </AutoSizer>
          )}
        </WindowScroller>
      </div>
    )
  }
  return (
    <div className="list-view view">
      <AutoSizer>
        {({ height, width }) => {
          return (
            <Table
              disableHeader
              width={width}
              height={height}
              headerHeight={0}
              rowHeight={178}
              rowCount={props.listItems.length}
              rowGetter={({ index }) => {
                const first = props.listItems[index]
                first.onClick = props.onClick
                return {
                  first,
                }
              }}
            >
              <Column
                cellRenderer={cellRenderer}
                dataKey="first"
                label="First"
                width={width}
              />
            </Table>
          )
      }}
      </AutoSizer>
    </div>
  )
}
ListView.propTypes = {
  onClick: func.isRequired,
  listItems: arrayOf(shape({
    city: string,
    country: string,
    hall_uses: arrayOf(string),
    image: string,
    name: string.isRequired,
    seat_count: number,
    site_building: string.isRequired,
    state_province_abbreviation: string,
    url: string.isRequired,
    year_built: number,
    year_renovated: arrayOf(number),
  })).isRequired,
  useWindowScroller: bool.isRequired,
}

export default ListView
